import { api } from "./client";

/** Един ред от „Справка монитори" — продуктов ред/добавка с
 *  времената по кухненската ос (0→1→2→3) и waiter оста (сервирано).
 *  Времената са първите преходи към статуса; null = не е минал през него. */
export interface KitchenMonitorReportRow {
  bill_id: number;
  bill_name: string;
  bill_element_item_id: number;
  is_addition: boolean;
  item_id: number;
  item_name: string;
  station_id: number;
  station_name: string;
  /** Decimal от BE → JSON низ. */
  quantity: string;
  ordered_at: string | null;
  started_at: string | null;
  cooked_at: string | null;
  issued_at: string | null;
  served_at: string | null;
  seconds_to_start: number | null;
  seconds_cooking: number | null;
  seconds_to_issue: number | null;
  seconds_to_serve: number | null;
  started_by: string | null;
  cooked_by: string | null;
  issued_by: string | null;
  served_by: string | null;
}

export interface KitchenMonitorReportSummary {
  items_count: number;
  avg_seconds_to_start: number | null;
  avg_seconds_cooking: number | null;
  avg_seconds_to_issue: number | null;
  avg_seconds_to_serve: number | null;
}

export interface KitchenMonitorReportResponse {
  rows: KitchenMonitorReportRow[];
  summary: KitchenMonitorReportSummary;
}

export interface KitchenMonitorReportFilters {
  start_date?: string;
  end_date?: string;
  /** Филтърът „смяна" (`lib/reportShift.ts`); без него — всички смени. */
  shift?: number;
  station_id?: number;
  changed_by?: number;
}

export const getKitchenMonitorReport = async (
  filters: KitchenMonitorReportFilters,
): Promise<KitchenMonitorReportResponse> => {
  const response = await api.get<KitchenMonitorReportResponse>(
    "/reports/analytics/kitchen-monitors",
    { params: filters },
  );
  return response.data;
};
